import React from 'react';
import ContenedorAplicacionCV from '../contenedorAplicacion/controladorVista/contenedorAplicacionCV';

const ContenedorAplicacion: React.FunctionComponent = () => (
  <ContenedorAplicacionCV />
);

export default ContenedorAplicacion;
